import React from 'react';
import Placeholder from '../Placeholder';
import { Button } from 'react-bootstrap';
import moment from 'moment/moment';
import FontAwesome from '../../utils/FA';
import PropTypes from 'prop-types';
import './styles/ReportRunButtons.scss';

const ReportRunButtons = ({
  runReport,
  forceRunReport,
  showSingleButton,
  showBothButtons,
  disableRunButton,
  disableRerunButton,
  showTimestamp,
  generatedAt
}) => {
  const loadingMessage = () => (
    <div className='placeholder-loading'>
      <FontAwesome name='spinner' spin />
      &nbsp;Your report is being prepared. It will appear here once completed. The report will also be available on the User Jobs page.
    </div>
  );

  return <React.Fragment>
    <Placeholder.invisible ready={showSingleButton}>
      <div className='async-report-button'>
        <Button onClick={runReport}>Run Report</Button>
      </div>
    </Placeholder.invisible>

    <Placeholder.invisible ready={showBothButtons}>
      <div className="async-report-button-row">
        <div className="left">
          <Button disabled={disableRunButton} onClick={runReport}>Run Report</Button>
        </div>
        <div className="right">
          <Button disabled={disableRerunButton} onClick={forceRunReport}>Rerun Current
            Report</Button>
        </div>
      </div>

      <Placeholder.loading ready={showTimestamp} loading={loadingMessage}>
        <h2 className="monthly-incremental-report-count">
          Report generated at:{' '}{moment(generatedAt)
          .format('MM/DD/YYYY hh:mm A')}
        </h2>
      </Placeholder.loading>
    </Placeholder.invisible>
  </React.Fragment>
}

ReportRunButtons.propTypes = {
  runReport: PropTypes.func.isRequired,
  forceRunReport: PropTypes.func.isRequired,
  showSingleButton: PropTypes.bool.isRequired,
  showBothButtons: PropTypes.bool.isRequired,
  disableRunButton: PropTypes.bool.isRequired,
  disableRerunButton: PropTypes.bool.isRequired,
  showTimestamp: PropTypes.bool.isRequired,
  generatedAt: PropTypes.string.isRequired
}

export default ReportRunButtons;
